import { render, staticRenderFns } from "./taxDetailList.vue?vue&type=template&id=6a92ef49&scoped=true&"
import script from "./taxDetailList.vue?vue&type=script&lang=js&"
export * from "./taxDetailList.vue?vue&type=script&lang=js&"
import style0 from "./taxDetailList.vue?vue&type=style&index=0&id=6a92ef49&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a92ef49",
  null
  
)

export default component.exports